import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from './Footer';
interface LegalLayoutProps {
  title: string;
  children: React.ReactNode;
}
export function LegalLayout({
  title,
  children
}: LegalLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background flex flex-col" data-id="element-132">
      <header className="py-8 px-6 border-b border-border bg-card" data-id="element-133">
        <div className="container max-w-[800px] mx-auto" data-id="element-134">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8" data-id="element-135">
            <ArrowLeft className="w-4 h-4" data-id="element-136" />
            Volver al inicio
          </Link>
          <h1 className="text-4xl md:text-5xl font-serif text-foreground" data-id="element-137">
            {title}
          </h1>
        </div>
      </header>

      <main className="flex-grow py-16 px-6" data-id="element-138">
        <div className="container max-w-[800px] mx-auto prose prose-stone prose-headings:font-serif prose-p:font-light prose-p:text-muted-foreground prose-a:text-accent" data-id="element-139">
          {children}
        </div>
      </main>

      <Footer data-id="element-140" />
    </div>;
}